/** Convierte cualquier error de axios (incluidos los 422 de Pydantic) en texto seguro para la UI. */
export function errorText(error, fallback = 'Algo no salió bien') {
  const detail = error?.response?.data?.detail ?? error?.response?.data?.message;
  if (!detail) return error?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map((d) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean);
    return msgs.length ? msgs.join(' · ') : fallback;
  }
  if (typeof detail === 'object') return detail.msg || JSON.stringify(detail).slice(0, 200);
  return fallback;
}

export default errorText;
